import { Circle, Calendar, ShoppingBag, Link } from "react-feather";

import {
  BOOKING_LIST_PATH,
  PRODUCT_LIST_PATH,
  SERVICE_LIST_PATH,
  DEEPLINK_LIST_PATH,
} from "@src/views/apps/operations/paths";
import { navPerm } from "../navPermissions";
import { PERMISSION_MODULE } from "@src/utility/permissions/modulePermissions";

export default [
  {
    header: "Operations",
  },
  {
    id: "operations",
    title: "Operations",
    icon: <Calendar size={20} />,
    children: [
      {
        id: "bookings",
        title: "Bookings",
        icon: <Circle size={12} />,
        navLink: BOOKING_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.BOOKING),
      },
      {
        id: "products",
        title: "Products",
        icon: <Circle size={12} />,
        navLink: PRODUCT_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.PRODUCT),
      },
      {
        id: "services",
        title: "Services",
        icon: <Circle size={12} />,
        navLink: SERVICE_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.SERVICE),
      },
      {
        id: "deeplinks",
        title: "Deeplinks",
        icon: <Link size={12} />,
        navLink: DEEPLINK_LIST_PATH,
        ...navPerm(PERMISSION_MODULE.DEEPLINK),
      },
    ],
  },
];
